import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import Checklist from "./Checklist";
import UseLogging from "../hooks/useLogging";

const App = () => {
  // UseLogging();

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/checklist/:phase/:task" element={<Checklist />} />
      <Route path="*" element={<div>PAGE NOT FOUND</div>} />
    </Routes>
  );
};

export default App;
